import axios from 'axios';
import $ from 'jquery';
import { getLogger } from '../services/logger';

const debug = getLogger('service-worker:sw-helper');

export function newSessionActions() {
  if (!('serviceWorker' in navigator)) return;

  // clear caches
  cleanCaches();

  // request statics and store them in cache
  forceStaticsRequest();
}

// clear custom caches
function cleanCaches() {
  navigator.serviceWorker.ready.then(reg => {
    reg.active.postMessage(
      JSON.stringify({
        clean: true
      })
    );
  });
}

function forceStaticsRequest() {
  // wait for SW to be registered
  setTimeout(() => {
    // load config
    requestStatic('/static/js/config.js');

    // load main bundle
    let mainBundlePath = $("script[src^='/static/js/main']").attr('src');
    if (mainBundlePath) requestStatic(mainBundlePath);

    // load main css
    let mainCssPath = $("link[href^='/main']").attr('href');
    if (mainCssPath) requestStatic(mainCssPath);
  }, 2000);
}

function requestStatic(resource) {
  if (resource) {
    debug('Forcing resource request: %s', resource);
    let resourcePath = `${process.env.PUBLIC_URL}${resource}`;
    axios.get(resourcePath).catch(error => {
      debug.error('request static failed %s', error);
    });
  }
}
